module.exports = __webpack_public_path__ + "img/washing.a23f17ef.svg";